<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   width="2000"
   height="1456"
   viewBox="0 0 529.16665 385.23334"
   version="1.1"
   id="svg110"
   inkscape:version="1.1.2 (0a00cf5339, 2022-02-04)"
   sodipodi:docname="left.svg"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:xlink="http://www.w3.org/1999/xlink"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <sodipodi:namedview
     id="namedview112"
     pagecolor="#ffffff"
     bordercolor="#000000"
     borderopacity="0.25"
     inkscape:pageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     inkscape:document-units="mm"
     showgrid="false"
     units="px"
     inkscape:zoom="0.47700626"
     inkscape:cx="982.1674"
     inkscape:cy="730.59838"
     inkscape:window-width="1920"
     inkscape:window-height="1137"
     inkscape:window-x="1920"
     inkscape:window-y="1200"
     inkscape:window-maximized="1"
     inkscape:current-layer="layer3"
     showguides="false" />
  <defs
     id="defs107">
    <style
       type="text/css"
       id="style2">.dataURL { &quot;);            font-display:auto;font-style:normal;font-weight:400;font-stretch:normal; }
</style>
  </defs>
  <g
     inkscape:groupmode="layer"
     id="layer3"
     inkscape:label="Left Text"
     style="display:inline">
    <path
       style="fill:none;stroke-width:0.264583;-inkscape-stroke:none;stop-color:#000000"
       d="M 24.368043,332.77778 V 61.858828"
       id="path879" />
    <text
       xml:space="preserve"
       style="font-weight:bold;font-size:22.9306px;line-height:normal;font-family:my-custom-font;-inkscape-font-specification:my-custom-font;text-align:center;text-decoration-color:#000000;text-anchor:middle;fill:none;stroke-width:0.264583;-inkscape-stroke:none;stop-color:#000000"
       id="text6001"
       transform="translate(-1.5875)"><textPath
         xlink:href="#path879"
         startOffset="50%"
         id="textPath7402"
         style="font-size:22.9306px;fill:#000000;fill-opacity:1;stroke-width:0.264583"
         rotate="0" /></text>
  </g>
</svg>
